<template>
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
      d="M8.00003 15.1111C11.9274 15.1111 15.1111 11.9274 15.1111 8.00003C15.1111 4.07267 11.9274 0.888916 8.00003 0.888916C4.07267 0.888916 0.888916 4.07267 0.888916 8.00003C0.888916 11.9274 4.07267 15.1111 8.00003 15.1111Z"
      stroke="#B5C6D8" stroke-width="1.3"/>
  <path d="M3.02228 12.9778L12.9778 3.02222" stroke="#B5C6D8" stroke-width="1.3"/>
</svg>
</template>
